import type { AxiosResponse } from 'axios';
import type { DocumentFileDto } from '../api/generated/client';

export const saveAsFile = (data: any, filename: string, applicationType: string) => {
    const blob = new Blob([data], { type: applicationType });
    // @ts-expect-error msSaveOrOpenBlob is deprecated and only here as a fallback
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // @ts-expect-error msSaveOrOpenBlob is deprecated and only here as a fallback
        window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        const a: any = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        const href = URL.createObjectURL(blob);
        a.href = href;
        a.download = filename.replace(/"/g, '');
        a.target = '_blank';
        a.click();
        window.URL.revokeObjectURL(href);
    }
};

export const saveFileFromResponse = (response: AxiosResponse) => {
    const contentDisposition = response.headers['content-disposition'];
    const contentType = response.headers['content-type'];
    const filename = typeof contentDisposition === 'string' ? contentDisposition.split('filename=')[1] : '';
    const applicationType = typeof contentType === 'string' ? contentType : 'application/octet-stream';
    saveAsFile(response.data, filename, applicationType);

    return true;
};

export const sortDocumentFileByLanguage = (a: DocumentFileDto, b: DocumentFileDto) => {
    const aLanguage = a.language;
    const bLanguage = b.language;

    // Both have languages: sort alphabetically
    if (aLanguage && bLanguage) {
        if (aLanguage < bLanguage) return -1;

        return aLanguage > bLanguage ? 1 : 0;
    }

    if (aLanguage) return -1;

    if (bLanguage) return 1;

    return 0;
};
